<script lang="ts">
	import { Genres } from '$lib/Globals';
	import { PersonalizationTypes } from '$lib/types/Personalization';
	import { personalizationTracking } from '@tools/PersonalizationTracking';

	const {
		data,
		gap = '',
		onclick
	}: {
		data: { slug: string; id: string; hash?: string }[];
		gap?: string;
		onclick?: () => void;
	} = $props();
</script>

{#each data as genre}
	{@const data = Genres.getById(genre.id)}
	{#if data}
		<a
			class="genre"
			href={data.path}
			onclick={() => {
				personalizationTracking.track(PersonalizationTypes.GENRE, [genre.id]);
				if (onclick) onclick();
			}}>{data.hash ?? `#${data.slug}`}</a
		>{gap}
	{/if}
{/each}

<style lang="scss">
	a {
		text-decoration: none;

		&:hover {
			text-decoration: underline;
		}
	}
</style>
